import { Route, Navigate, Routes } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import { Loading } from 'components/Loading';
import { useJobBoards } from 'jobboards/useJobBoards';

import { PromotePostList } from './promote-post-list';
import { PromoteCreate } from './PromoteCreate';
import { PromoteEmptyBoardList } from './PromoteEmptyBoardList';

export const Promote = observer(({ job }) => {
  const { status, boards, activeBoards } = useJobBoards();

  if (status === 'loading') return <Loading delay={1000} />;

  if (activeBoards.length === 0) return <PromoteEmptyBoardList />;

  return (
    <Routes>
      <Route path="/" element={<PromotePostList jobID={job.id} boards={boards} />} />
      <Route path="tvinna" element={<PromotePostList jobID={job.id} boards={boards} />} />
      <Route path="new" element={<PromoteCreate job={job} boards={activeBoards} />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
});
